import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';
import { CountryName } from '../../models/country/country-name.enum';

export function countryNameFactory(
  countryIsoNumber: CountryIsoNumber,
): CountryName {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return CountryName.Ireland;
    case CountryIsoNumber.GreatBritain:
    default:
      return CountryName.GreatBritain;
  }
}
